module.exports = __webpack_public_path__ + "static/media/online_logo.4543131d.png";